import {
  SpaceBetween,
  Icon,
  Header,
  TextContent,
  Alert,
  Container,
  Button,
  Spinner,
} from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AMBASSADOR_EXTERNAL_PLAN_EVENT_LINK } from '../../utils/constants';

export function AmbassadorRenewalConfirmationSuccess() {
  const { t } = useTranslation(['ambassadors', 'translation']);
  const navigate = useNavigate();

  return (
    <SpaceBetween direction="vertical" size="s" alignItems="center">
      <Icon name="status-positive" size="large" variant="success" />
      <Header variant="h1">{t('ambassadorRenewalConfirmation.thankYou')}</Header>
      <TextContent>
        <p>{t('ambassadorRenewalConfirmation.yourActive')}</p>
      </TextContent>
      <Alert statusIconAriaLabel="Success">
        <b>{t('ambassadorRenewalConfirmation.nextCheckIn')}</b>{' '}
        {t('ambassadorRenewalConfirmation.wellReachOut')}
      </Alert>
      <Container fitHeight data-ambassador-renewal-confirmation-container>
        <SpaceBetween direction="vertical" size="s" alignItems="center">
          <Header variant="h2">{t('ambassadorRenewalConfirmation.keepMaking')}</Header>
          {t('ambassadorRenewalConfirmation.readyToPlan')}
          <Button
            data-testid="plan-event-button"
            href={AMBASSADOR_EXTERNAL_PLAN_EVENT_LINK}
            external
          >
            {t('ambassadorRenewalConfirmation.planEvent')}
          </Button>
          {t('ambassadorRenewalConfirmation.or')}
          <Button
            data-testid="view-in-your-area-button"
            onClick={() => navigate('/ambassadors?in-your-area=true')}
            variant="inline-link"
          >
            {t('ambassadorRenewalConfirmation.viewAmbassadors')}
          </Button>
        </SpaceBetween>
      </Container>
    </SpaceBetween>
  );
}

export function AmbassadorRenewalConfirmationError() {
  const { t } = useTranslation(['ambassadors', 'translation']);
  const navigate = useNavigate();

  return (
    <SpaceBetween direction="vertical" size="s" alignItems="center">
      <Icon name="status-negative" size="large" variant="error" />
      <Header variant="h1">{t('ambassadorRenewalConfirmation.thereWasAProblem')}</Header>
      <TextContent>
        <p>{t('ambassadorRenewalConfirmation.reachOut')}</p>
      </TextContent>
      <Button data-testid="ambassador-directory-button" onClick={() => navigate('/ambassadors')}>
        {t('ambassadorRenewalConfirmation.viewDirectory')}
      </Button>
    </SpaceBetween>
  );
}

export const VerifyingSpinner = () => {
  const { t } = useTranslation(['ambassadors', 'translation']);
  return (
    <Container>
      <SpaceBetween direction="vertical" size="s" alignItems="center">
        <Spinner size="large" />
        <span>{t('ambassadorRenewalConfirmation.verifying')}</span>
      </SpaceBetween>
    </Container>
  );
};
